<template>
  <v-dialog v-model="active">
    <v-card class="pb-3">
      <v-card-title class="text-h5"></v-card-title>
      <v-card-text style="height: 350px">
        <video v-if="videoUrl" style="width: 100%; height: 100%" controls preload="metadata">
          <source :src="videoUrl" type="video/mp4" />
        </video>
      </v-card-text>
      <v-card-actions>
        <v-btn color="blue-grey darken-1" block depressed outlined dark @click="closeModal"> Voltar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  emits: ['close'],
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    videoUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      active: false
    };
  },
  watch: {
    isActive(newValue) {
      this.active = newValue;
    },
    active(newValue) {
      if (!newValue) {
        this.closeModal();
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    saveModal() {
      this.$emit('save');
    }
  }
};
</script>
